// // import Chart from "react-apexcharts";
// // import { getDashboardDetailsGraph } from "../../../services/api-services";
// // import { useEffect, useState } from "react";

// // const DashboardChart = () => {
// //   const [rowData, setRowData] = useState([]);
// //   const [pending, setPending] = useState(true); // Initially set to true to show loading state

// //   const [chartData, setChartData] = useState({
// //     series: [],
// //     options: {
// //       chart: {
// //         type: "donut",
// //       },
// //       labels: [],
// //       colors: ["#28a745", "#ffc107", "#dc3545"], 
// //       legend: {
// //         position: "right",
// //         offsetY: 60,
// //         horizontalAlign: "left",
// //         fontSize: "14px",
// //         markers: {
// //           shape: "square",
// //         },
// //       },
// //       plotOptions: {
// //         pie: {
// //           donut: {
// //             size: "70%",
// //             labels: {
// //               show: true,
// //               total: {
// //                 show: true,
// //                 showAlways: true,
// //                 label: "Total",
// //               },
// //             },
// //           },
// //         },
// //       },
// //       stroke: {
// //         width: 0,
// //       },
// //       dataLabels: {
// //         enabled: true,
// //         formatter: (val, opts) => {
// //           const value = opts.w.config.series[opts.seriesIndex];
// //           return `${value}`;
// //         },
// //         style: {
// //           fontSize: "10px",
// //         },
// //       },
// //       tooltip: {
// //         enabled: true,
// //         y: {
// //           formatter: (val) => `${val} participants`,
// //         },
// //       },
// //     },
// //   });

// //   const getDashboardDetails = async () => {
// //     try {
// //       setPending(true);
// //       const response = await getDashboardDetailsGraph();
// //       if (response?.data?.responseCode === 200) {
// //         const data = response?.data?.responseBody?.dashboardResponseGraphList;

// //         // Dynamically set series and labels based on the API response
// //         const series = data.map(item => item.count);
// //         const labels = data.map(item => item.modelName || item.sortName); // Fallback to sortName if modelName is null

// //         setChartData((prevState) => ({
// //           ...prevState,
// //           series: series,
// //           options: {
// //             ...prevState.options,
// //             labels: labels,
// //           },
// //         }));
// //         setPending(false);
// //       } else {
// //         setRowData([]);
// //         setPending(false);
// //       }
// //     } catch (error) {
// //       setPending(false);
// //     }
// //   };

// //   useEffect(() => {
// //     getDashboardDetails();
// //   }, []);

// //   return (
// //     <div>
// //       <h5>My Assessment</h5>
// //       <Chart
// //         options={chartData.options}
// //         series={chartData.series}
// //         type="donut"
// //         width="460"
// //         height={300}
// //       />
// //     </div>
// //   );
// // };

// // export default DashboardChart;

// import Chart from "react-apexcharts";
// import { getDashboardDetailsGraph } from "../../../services/api-services";
// import { useEffect, useState } from "react";

// const DashboardChart = () => {
//   const [pending, setPending] = useState(true);

//   const [chartData, setChartData] = useState({
//     series: [],
//     options: {
//       chart: {
//         type: "donut",
//       },
//       labels: [],
//       colors: ["#28a745", "#ffc107", "#dc3545"],
//       legend: {
//         position: "right",
//         offsetY: 60,
//         horizontalAlign: "left",
//         fontSize: "14px",
//         markers: {
//           shape: "square",
//         },
//       },
//       plotOptions: {
//         pie: {
//           donut: {
//             size: "70%",
//             labels: {
//               show: true,
//               total: {
//                 show: true,
//                 showAlways: true,
//                 label: "Total",
//                 formatter: () => "0", 
//               },
//             },
//           },
//         },
//       },
//       stroke: {
//         width: 0,
//       },
//       dataLabels: {
//         enabled: true,
//         formatter: (val, opts) => {
//           const value = opts.w.config.series[opts.seriesIndex];
//           return `${value}`;
//         },
//         style: {
//           fontSize: "10px",
//         },
//       },
//       tooltip: {
//         enabled: true,
//         y: {
//           formatter: (val) => `${val} participants`,
//         },
//       },
//     },
//   });

//   const getDashboardDetails = async () => {
//     try {
//       setPending(true);
//       const response = await getDashboardDetailsGraph();

//       if (response?.data?.responseCode === 200) {
//         const data = response?.data?.responseBody?.dashboardResponseGraphList;
//         const totalFromAPI = response?.data?.responseBody?.totalCount;

//         const series = data.map(item => item.count);
//         const labels = data.map(item => item.modelName || item.sortName);

//         setChartData((prevState) => ({
//           ...prevState,
//           series: series,
//           options: {
//             ...prevState.options,
//             labels: labels,
//             plotOptions: {
//               ...prevState.options.plotOptions,
//               pie: {
//                 ...prevState.options.plotOptions.pie,
//                 donut: {
//                   ...prevState.options.plotOptions.pie.donut,
//                   labels: {
//                     ...prevState.options.plotOptions.pie.donut.labels,
//                     total: {
//                       ...prevState.options.plotOptions.pie.donut.labels.total,
//                       formatter: () => `${totalFromAPI}`, // Set total from API
//                     },
//                   },
//                 },
//               },
//             },
//           },
//         }));
//       } else {
//         setChartData((prevState) => ({
//           ...prevState,
//           series: [],
//           options: {
//             ...prevState.options,
//             labels: [],
//           },
//         }));
//       }
//     } catch (error) {
//       console.error("Dashboard API Error:", error);
//     } finally {
//       setPending(false);
//     }
//   };

//   useEffect(() => {
//     getDashboardDetails();
//   }, []);

//   return (
//     <div>
//       <h5>My Assessment</h5>
//       {!pending ? (
//         <Chart
//           options={chartData.options}
//           series={chartData.series}
//           type="donut"
//           width="460"
//           height={300}
//         />
//       ) : (
//         <p>Loading chart...</p>
//       )}
//     </div>
//   );
// };

// export default DashboardChart;

import Chart from "react-apexcharts";
import { getDashboardDetailsGraph } from "../../../services/api-services";
import { useEffect, useState } from "react";

const DashboardChart = () => {
  const [pending, setPending] = useState(true);
  const [hasData, setHasData] = useState(false);

  const [chartData, setChartData] = useState({
    series: [100],
    options: {
      chart: { type: "donut" },
      labels: ["No data available"],
      colors: ["#d3d3d3"], // Light gray color
      legend: { show: false },
      plotOptions: {
        pie: {
          donut: {
            size: "70%",
            labels: {
              show: true,
              total: {
                show: true,
                label: "No Data",
                formatter: () => "0",
              },
            },
          },
        },
      },
      dataLabels: { enabled: false },
    },
  });

  const getDashboardDetails = async () => {
    try {
      setPending(true);
      const response = await getDashboardDetailsGraph();

      if (response?.data?.responseCode === 200) {
        const data = response?.data?.responseBody?.dashboardResponseGraphList;
        const totalFromAPI = response?.data?.responseBody?.totalCount;

        if (!data || data.length === 0) {
          setHasData(false);
          return; // Keep default “No data” chart
        }

        const series = data.map((item) => item.count);
        const labels = data.map((item) => item.modelName || item.sortName);

        setChartData((prevState) => ({
          ...prevState,
          series,
          options: {
            ...prevState.options,
            labels,
            colors: ["#28a745", "#ffc107", "#dc3545"],
            legend: {
              position: "right",
              offsetY: 60,
              horizontalAlign: "left",
              fontSize: "14px",
              markers: { shape: "square" },
            },
            plotOptions: {
              ...prevState.options.plotOptions,
              pie: {
                ...prevState.options.plotOptions.pie,
                donut: {
                  ...prevState.options.plotOptions.pie.donut,
                  labels: {
                    ...prevState.options.plotOptions.pie.donut.labels,
                    total: {
                      ...prevState.options.plotOptions.pie.donut.labels.total,
                      label: "Total",
                      formatter: () => `${totalFromAPI || 0}`,
                    },
                  },
                },
              },
            },
            dataLabels: {
              enabled: true,
              formatter: (val, opts) => {
                const value = opts.w.config.series[opts.seriesIndex];
                return `${value}`;
              },
              style: { fontSize: "10px" },
            },
          },
        }));
        setHasData(true);
      } else {
        setHasData(false);
      }
    } catch (error) {
      console.error("Dashboard API Error:", error);
      setHasData(false);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    getDashboardDetails();
  }, []);

  return (
    <div
      style={{
        borderRadius: "10px",
        minHeight: "290px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: pending ? "center" : "flex-start",
      }}
    >
      <h5 style={{ alignSelf: "flex-start" }}>My Assessment</h5>

      {pending ? (
        <p>Loading chart...</p>
      ) : hasData || chartData.series.length > 0 ? (
        <Chart
          options={chartData.options}
          series={chartData.series}
          type="donut"
          width="420"
          height={250}
        />
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#666",
            fontSize: "16px",
          }}
        >
          No data available
        </div>
      )}
    </div>
  );
};

export default DashboardChart;

